import axios from "axios";
import moment from "moment-timezone"; // Import moment-timezone
import { useEffect, useRef, useState } from "react";
import DatePicker from "react-datepicker";
import { IoIosArrowDown as ArrowDown } from "react-icons/io";
import { NotificationManager } from "react-notifications";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useParams } from "react-router-dom";
import SearchDropdown from "../../../components/Dropdowns/SearchDropdown";
import Loader from "../../../components/Loader";
import Modal from "../../../components/Modal/Modal";
import { useSelectedOptions } from "../../../context/selectedOptionsContext";
import useAuth from "../../../hooks/useAuth";
import { BASE_URL } from "../../../utils/Element";
import { activityOptions } from "../../../utils/options";
import { handleDropdownClose } from "../../../utils/utils";


const today = moment.tz(new Date(), "America/New_York").format("YYYY-MM-DD");

const initialFormData = {
  date: today,
  description: "",
  interaction_type: "",
  contact_name: "",
};

const AddActivityModal = ({ showModal, onClose, showContact = true, from, selectedItem, onSuccess }) => {
  const { id } = useParams();
  const [config] = useAuth();
  const dropdownRef = useRef(null);
  const [error, setError] = useState();
  const [search, setSearch] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [description, setDescription] = useState("");
  const [contactId, setContactId] = useState("");
  const { setIsEditedactivity } = useSelectedOptions();
  const [contactOptions, setContactData] = useState([]);
  const [formData, setFormData] = useState(initialFormData);
  const [addactivityerror, setAddactivityerror] = useState("");

  const handleChange = (value, name) => {
    setError({ ...error, [name]: "" });
    setFormData({ ...formData, [name]: value });
  };

  const handleDescriptionChange = (html) => {
    setFormData((prevData) => ({
      ...prevData,
      description: html,
    }));
    setError((prevError) => ({ ...prevError, description: "" }));
  };

  useEffect(() => {
    const handleClose = () => {
      setIsOpen(false);
    };
    handleDropdownClose(dropdownRef, handleClose);
  }, []);

  const fetchSuggestions = (inputValue) => {
    if (inputValue !== "") {
      axios
        .get(`${BASE_URL}/get-datalisting?list=contacts&search=${inputValue}&company_id=${id}`, config)
        .then((res) => {
          const data = res?.data?.data;
          const contactOptions = data?.contact_list?.map((el) => ({
            value: el?.id,
            label: `${el?.first_name} ${el?.last_name}`,
          }));
          setContactData(contactOptions);
        })
        .catch((err) => {
          if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
            NotificationManager.error(err.response?.data?.message);
          }
        });
    } else {
      setContactData([]);
    }
  };

  const handleClose = () => {
    setFormData(initialFormData);
    setContactId("");
    onClose();
    setError();
    setAddactivityerror();
  };

  const handleSubmitData = (e) => {
    const newYorkDate = moment.tz(formData.date, "America/New_York").format("YYYY-MM-DD HH:mm:ss");

    const dataToSend =
      from === "contact"
        ? {
          interaction_type: formData?.interaction_type,
          date: newYorkDate,
          description: formData?.description,
          contact_id: id,
        }
        : {
          interaction_type: formData?.interaction_type,
          date: newYorkDate,
          description: formData?.description,
          contact_id: contactId,
          company_id: id,
        };

    axios
      .post(`${BASE_URL}/add-activity`, dataToSend, config)
      .then((res) => {
        handleClose();
        onSuccess();
        if (res?.data?.message) {
          NotificationManager.success(res?.data?.message);
        }
      })
      .catch((err) => {
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
        setError(err.response.data.errors ? err.response.data.errors : err.response.data.message);
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newYorkDate = moment.tz(formData.date, "America/New_York").format("YYYY-MM-DD HH:mm:ss");

    if (from === "pagination") {
      const dataToSend = {
        action: "add_activity",
        ids: selectedItem,
        type: "contact",
        activity: {
          interaction_type: formData.interaction_type,
          date: newYorkDate,
          description: formData.description,
        },
      };

      axios
        .post(`${BASE_URL}/handleBulk-Actions`, dataToSend, config)
        .then((res) => {
          handleClose();
          onSuccess();
          if (res?.data?.message) {
            NotificationManager.success(res?.data?.message);
          }
        })
        .catch((error) => {
          if (error.response?.data?.message) {
            NotificationManager.error(error.response?.data?.message);
          }
          setAddactivityerror(
            error.response.data.errors
              ? error.response.data.errors
              : error.response.data.message
          );
        });
    } else {
      handleSubmitData();
    }
  };

  const todayNY = moment
  .tz("America/New_York")
  .endOf("day")
  .toDate();


  return (
    <Modal title={"Add New Activity"} desc={`Add a new activity to ${from === "pagination" ? "contact" : from}.`} show={showModal} onClose={handleClose}>
      {loading ? (
        <Loader />
      ) : (
        <form onSubmit={handleSubmit} className="py-3">
          {showContact && (
            <div className="mb-6">
              <p className="head-4 dark-H mb-2">
                Contact
              </p>
              <div className="flex-1">
                <SearchDropdown
                  isTop={false}
                  placeholder="Search Contact Here..."
                  text={formData?.contact_name}
                  options={contactOptions}
                  fetchSuggestions={fetchSuggestions}
                  onSetOptions={(value) => setContactData(value)}
                  handleSelect={(option) => {
                    setError((prevErrors) => ({ ...prevErrors, contact_id: "" }));
                    setContactId(option.value);
                    handleChange(option.label, "contact_name");
                    setContactData([]);
                  }}
                />
              </div>
              {error?.contact_id && <p className="red-D body-S">{error?.contact_id}</p>}
            </div>
          )}
          <div className="flex gap-3 items-center">
            <div className="mt-5 md:mt-0 w-[50%]">
              <p className="head-4 dark-H">
                Interaction Type<span className="red-D">*</span>
              </p>
              <div ref={dropdownRef} className="custom-dropdown mt-2">
                <div role="button" className="select-header-input capitalize light-bg-L body-N dark-M flex justify-between items-center" onClick={() => setIsOpen(!isOpen)}>
                  {formData.interaction_type === ""
                    ? "Select"
                    : activityOptions.find((el) => el.value === formData.interaction_type).label}{" "}
                  <ArrowDown />
                </div>
                {isOpen && (
                  <div className="dropdown-list-container light-bg-L dark-M body-N shadow rounded-box w-52 ">
                    <ul className="dropdown-list">
                      {activityOptions.map((el, i) => (
                        <li
                          key={i}
                          role="button"
                          onClick={() => {
                            handleChange(el.value, "interaction_type");
                            setIsOpen(false);
                          }}
                          className={`${formData.interaction_type === el.value ? "active" : ""}`}
                        >
                          {el.label}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>

              {addactivityerror?.interaction_type && <p className="body-S red-D">{addactivityerror?.interaction_type}</p>}
              {error?.interaction_type && <p className="body-S red-D">{error?.interaction_type}</p>}
            </div>

            <div className="mt-5 md:mt-0 w-[50%]">
              <p className="head-4 dark-H">
                Date<span className="red-D">*</span>
              </p>
              <div className="mt-1">
                <DatePicker
                  className="body-N"
                  dateFormat="MM/dd/yyyy"
                  placeholderText="MM/DD/YYYY"
                  selected={
                    formData.date
                      ? moment.tz(formData.date, "America/New_York").startOf("day").toDate()
                      : null
                  }
                  onChange={(date) => {
                    const selectedDate = moment(date)
                      .tz("America/New_York")
                      .startOf("day")
                      .toDate();

                    handleChange(selectedDate, "date");
                  }}
                 maxDate={todayNY} 
                />



              </div>

              {addactivityerror?.date && <p className="body-S red-D">{addactivityerror?.date}</p>}
              {error?.date && <p className="body-S red-D">{error?.date}</p>}
            </div>

          </div>

          <div className="flex-1 mt-4">
            <p className="head-4 dark-H">Description</p>
            <ReactQuill value={formData?.description} onChange={handleDescriptionChange} />
            {addactivityerror?.description && <p className="body-S red-D">{addactivityerror?.description}</p>}
            {error?.description && <p className="body-S red-D">{error?.description}</p>}
          </div>

          <div className="save-button light-L head-5 green-bg-H mt-4">
            <button type="submit" className="btn-1">
              Save
            </button>
          </div>
        </form>
      )}
    </Modal>
  );
};

export default AddActivityModal;
